module.exports = __webpack_public_path__ + "img/johnnys-backpack.ce610622.jpg";